import {IHttpService, IPromise} from "angular";
import {AsxGameDates} from "./AsxGameDates";

export class AsxGameService {

    public static id = "asxGameService";

    private _dates: IPromise<AsxGameDates>;

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async dates(): Promise<AsxGameDates> {
        if (this._dates == null) {
            const url = "/tradefloor/api/game/dates";
            this._dates = this.$http.get<AsxGameDates>(url)
                              .then(resp => resp.data!);
        }
        return this._dates;
    }
}
